module.exports = __webpack_public_path__ + "static/media/template-operator.445d8032.xlsx";